module.exports = __webpack_public_path__ + "img/feature2-2x.d966928.png";